const testimonials = [
  {
    id: 1,
    name: 'Alex Johnson',
    title: 'Senior Software Engineer',
    org: 'NextGen Labs',
    desc: 'Pranay consistently delivers high-quality work with clean, efficient code. His attention to detail and ability to quickly understand project requirements make him a reliable developer for any project.',
  },
  {
    id: 2,
    name: 'Maria Lee',
    title: 'Product Manager',
    org: 'InnovaTech Solutions',
    desc: 'An excellent collaborator with a strong sense of design and usability. Pranay’s work on our internal dashboard was both visually impressive and functionally robust.',
  },
  {
    id: 3,
    name: 'Rahul Desai',
    title: 'Cybersecurity Analyst',
    org: 'SecurePoint Inc.',
    desc: 'Pranay has a solid understanding of security-first development practices. His insights during our mock vulnerability testing sessions were insightful and highly valuable.',
  },
  {
    id: 4,
    name: 'Emily Carter',
    title: 'Head of Design',
    org: 'PixelWave Studio',
    desc: 'Working with Pranay was seamless. He translated our Figma designs into flawless, responsive web components and added meaningful animations that enhanced the user experience.',
  },
  {
    id: 5,
    name: 'Daniel Kim',
    title: 'AI Specialist',
    org: 'CognitionWorks',
    desc: 'Pranay’s grasp on AI/ML concepts and his ability to implement models in real applications is impressive. Even in simulated environments, his demo projects performed exceptionally well.',
  },
];

export default testimonials;
